module.exports = __webpack_public_path__ + "img/spiner.a8b43f13.svg";